(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const bar = section.querySelector('[data-mobile-buybar]');
      if (!bar || bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const primary = section.querySelector('[data-add-button]');
      const price = section.querySelector('[data-product-price]');
      const button = bar.querySelector('[data-sticky-add-button]');
      const sync = () => {button.disabled = primary.disabled; button.textContent = primary.textContent; bar.querySelector('[data-sticky-price]').textContent = price.textContent;};
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(primary, {attributes: true, childList: true, subtree: true});
      observer.observe(price, {childList: true, subtree: true});
      const visibility = new IntersectionObserver(entries => {bar.hidden = entries[0].isIntersecting;}, {threshold: 0.1});
      visibility.observe(primary);
      document.body.classList.add('tt-has-mobile-buybar');
      document.addEventListener('shopify:section:unload', event => {if (event.target.contains(section)) {observer.disconnect(); visibility.disconnect();}}, {once: true});
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
